import styled from 'styled-components';

interface IDividerProps {
	$width?: number;
	$height?: number;
	$top?: number;
	$left?: number;
	$bottom?: number;
	$right?: number;
	$direction: 'vertical' | 'horizontal';
}

const Divider = styled.div<IDividerProps>`
	width: ${(props) =>
		props.$width
			? `${props.$width}px`
			: props.$direction === 'vertical'
			? '1px'
			: '100%'};
	height: ${(props) =>
		props.$height
			? `${props.$height}px`
			: props.$direction === 'horizontal'
			? '1px'
			: '100%'};
	margin-top: ${(props) =>
		props.$top !== undefined
			? `${props.$top}px`
			: props.$direction === 'horizontal'
			? '40px'
			: 0};
	margin-bottom: ${(props) =>
		props.$bottom !== undefined
			? `${props.$bottom}px`
			: props.$direction === 'horizontal'
			? '40px'
			: 0};
	margin-left: ${(props) =>
		props.$left !== undefined
			? `${props.$left}px`
			: props.$direction === 'vertical'
			? '40px'
			: 0};
	margin-right: ${(props) =>
		props.$right !== undefined
			? `${props.$right}px`
			: props.$direction === 'vertical'
			? '40px'
			: 0};
	background-color: #d9d9d9;
	opacity: 0.1;
`;

export { Divider };
